import { formatDistanceToNow } from 'date-fns'

import type { SavedPrompt } from '../../api/prompts'

interface PromptListProps {
  prompts: SavedPrompt[]
}

export function PromptList({ prompts }: PromptListProps) {
  if (prompts.length === 0) {
    return (
      <div className="px-6 py-12 text-center">
        <div
          aria-hidden="true"
          className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-dashed border-emerald-500/50 bg-emerald-500/10 font-mono text-xl text-emerald-400"
        >
          {'{ }'}
        </div>
        <h3 className="text-base font-semibold text-harbor-text">No saved prompts</h3>
        <p className="mx-auto mt-2 max-w-lg text-sm text-harbor-text-secondary">
          Agents can add reusable instructions to this project with the{' '}
          <code className="font-mono text-emerald-400">save_prompt</code> MCP tool.
        </p>
      </div>
    )
  }

  return (
    <div className="divide-y divide-harbor-border">
      {prompts.map((prompt) => (
        <article key={prompt.id} className="group px-6 py-5">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0">
              <h3 className="text-base font-semibold text-harbor-text">{prompt.title}</h3>
              {prompt.tags.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1.5" aria-label="Prompt tags">
                  {prompt.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-md border border-emerald-500/20 bg-emerald-500/10 px-2 py-0.5 font-mono text-xs text-emerald-400"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <p className="shrink-0 text-xs text-harbor-text-muted">
              Updated {formatDistanceToNow(new Date(prompt.updatedAt), { addSuffix: true })}
            </p>
          </div>
          <pre className="mt-4 max-h-36 overflow-hidden whitespace-pre-wrap break-words rounded-lg border border-harbor-border bg-harbor-surface-raised/60 px-4 py-3 font-mono text-sm leading-6 text-harbor-text-secondary">
            {prompt.body}
          </pre>
        </article>
      ))}
    </div>
  )
}
